import _ from 'lodash'
import utils from '@/core/utils'

const state = {
  allFractions: [],
  selectedFractionTypes: []
}

const mutations = {
  update_selected_fraction_types(state, payload) {
    state.selectedFractionTypes = payload
  },
  set_fractions(state, payload) {
    state.allFractions = _.unionWith(state.allFractions, payload, _.isEqual)
  }
}

const actions = {
  updateSelectedFractionTypes({ commit }, payload) {
    utils.setQueryStringParameter('f', _.map(payload, (o) => { return encodeURIComponent(o.name) }).join('.'))
    commit('update_selected_fraction_types', payload)
  },
  setFractions({ commit }, payload) {
    commit('set_fractions', payload)
  },
  setFromQueryParams({ commit, getters }, payload) {
    const existingSelections = utils.getQueryStringParam('f')
    const fractionTypes = _.flatMap(getters.allFractions, 'fractionTypes')

    if(existingSelections) {
      const selectedFractionTypes = _.chain(existingSelections.split('.')).map(name => {
        return _.find(fractionTypes, ft => ft.name === name)
      }).compact().value()
      commit('update_selected_fraction_types', selectedFractionTypes)
      return selectedFractionTypes
    }
  }
}

const getters = {
  selectedFractionTypes: state => {
    const modelCode = utils.getModelCode()
    return _.filter(state.selectedFractionTypes, fraction => _.includes(fraction, modelCode))
  },
  allFractions: state => state.allFractions,
  fractionItemMap: state => {
    const modelCode = utils.getModelCode()

    return _.reduce(state.allFractions, (result, fraction) => {
      _.forEach(_.filter(fraction.fractionTypes, fraction => _.includes(fraction, modelCode)), fractionType => {
        _.forEach(fractionType.items, itemId => (result[itemId] = result[itemId] ? result[itemId] : []).push({ fraction, fractionType }))
      })
      return result
    }, {})
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
